import { Dispatch, SetStateAction } from "react";
import { Grid2 } from "@mui/material";
import { useRemoteFetchCompanyUnits } from "../../../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";
import { Stakeholder } from "../../../../../features/FloorManager/typings/permission.entity";
import { ServiceData } from "../ScheduleSelection-Tab-Services.component";
import { ServiceCateringDataTable } from "./ScheduleSelection-Tab-Services-CateringDataTable.partial";
import { CateringServiceSelectCostCenter } from "../../../../FacilityManager/Components/Views/SelectFloorPlanView/BookingServicePrompt/Catering/BookingService-CateringTable.partial";
import { NoPlaceZoneBooking } from "../../../../../features/Booking-Form/typings/booking-service-administration.types";
import { MaxSetUpTime } from "../../../../../features/Booking-Form/typings/booking-services.types";

type Props = {
  isMobile: boolean;
  isEditable: boolean;
  isColleagueScheduleEditable: boolean;
  cateringData: ServiceData[];
  setCateringData: Dispatch<SetStateAction<ServiceData[]>>;
  selectCostCenter: { id: string; name: string } | null;
  setSelectCostCenter: Dispatch<SetStateAction<{ id: string; name: string } | null>>;
  schedule: NoPlaceZoneBooking;
  remoteMaxSetupTime: MaxSetUpTime | undefined;
};

/**
 * @version 0.1.0
 */
export default function ScheduleSelectionServicesTabCatering({
  isMobile,
  isEditable,
  isColleagueScheduleEditable,
  cateringData,
  setCateringData,
  selectCostCenter,
  setSelectCostCenter,
  schedule,
  remoteMaxSetupTime
}: Readonly<Props>) {
  const { data: remoteDepartments } = useRemoteFetchCompanyUnits(Stakeholder.CostCenterUnit);
  const isCostExisting = cateringData.every(menu => menu.pricePerUnit && menu.pricePerUnit > 0);

  /** istanbul ignore next */
  const handleChangeCostCenter = (
    event: React.SyntheticEvent,
    value: { id: string; name: string } | null
  ) => {
    if (value) setSelectCostCenter(value);
    else setSelectCostCenter(null);
  };

  return (
    <>
      <Grid2 container sx={{ width: "100%" }}>
        {/* list of catering Data */}
        <ServiceCateringDataTable
          isEditable={isEditable}
          isColleagueScheduleEditable={isColleagueScheduleEditable}
          cateringData={cateringData}
          setCateringData={setCateringData}
          schedule={schedule}
          remoteMaxSetupTime={remoteMaxSetupTime}
        />
      </Grid2>

      <Grid2
        container
        sx={{ flexDirection: "column", pt: 2 }}
        data-testid="bookingService-department-box"
      >
        {cateringData.length > 0 && (
          <CateringServiceSelectCostCenter
            isMobile={isMobile}
            isEditable={false} // don't use cost center select yet
            isCostExisting={isCostExisting}
            remoteDepartments={remoteDepartments}
            cateringData={cateringData}
            handleChangeCostCenter={handleChangeCostCenter}
            selectCostCenter={selectCostCenter}
          />
        )}
      </Grid2>
    </>
  );
}
